import { c as _c } from "react/compiler-runtime";
import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { GET_NAVBAR_MENUS } from 'mocks/queries';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import scrollToTop from 'commons/scrollToTop';
import normalizeInternalLink from 'commons/normalizeInternalLink';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import ArrowDownSimples from 'components/icons/iconArrowDownSimple';
import CtaLink from 'components/essentials/Cta/CtaLink';
import useUserData from 'data-hooks/useUserData';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
import NavMenusContext from './NavMenusContext';
import IconUserAccount from '../../icons/iconUserAccount';
import ProgressLoader from '../../essentials/ProgressLoader/ProgressLoader';
import MobileShowroomLocator from './components/MobileShowroomLocator';
const ConsumerMobileFooterMenu = () => {
  const $ = _c(25);
  const isBrowser = useIsBrowser();
  const navMenusContextData = useContext(NavMenusContext);
  const shouldUseContextData = navMenusContextData != null;
  let t0;
  if ($[0] !== shouldUseContextData) {
    t0 = {
      skip: shouldUseContextData
    };
    $[0] = shouldUseContextData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: apolloData
  } = useSuspenseQuery(GET_NAVBAR_MENUS, t0);
  const data = shouldUseContextData ? navMenusContextData : apolloData;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [menuVisible, setMenuVisible] = useState(t1);
  const [signInModalVisible, setSignInModalVisible] = useState(false);
  const {
    isLoggedIn,
    firstName
  } = useUserData();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = menuType => {
      setMenuVisible(prevState => {
        const updatedMenu = cloneDeep(prevState);
        updatedMenu[menuType] = !updatedMenu[menuType];
        return updatedMenu;
      });
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const toggleMenu = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setSignInModalVisible(true);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const showSignInModal = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSignInModalVisible(false);
      scrollToTop();
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const hideSignInModal = t4;
  if (!data || data.loading) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="hidden max-[767px]:w-full max-[767px]:flex-col max-[767px]:justify-center max-[767px]:items-center max-[767px]:bg-white max-[767px]:flex max-[767px]:px-0 max-[767px]:py-4"><ProgressLoader color="dark-light" /></div>;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MobileShowroomLocator />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== data.getNavigationMenus || $[9] !== menuVisible) {
    t6 = data.getNavigationMenus && data.getNavigationMenus.learn?.map((t7, i) => {
      const {
        category
      } = t7;
      return category.map(t8 => {
        const {
          categoryTitle,
          subcategory
        } = t8;
        let categoryTitleLower = categoryTitle.toLowerCase();
        categoryTitleLower = categoryTitleLower.replace(" ", "");
        return <div className="w-full cursor-pointer border-b border-solid border-gray-light5" key={`${categoryTitleLower}_${i + 4}`}><button type="button" className="[background:none] border-0 flex w-full flex-row justify-between px-[3.333vw] py-4" onClick={() => toggleMenu(`${categoryTitleLower}`)}><div className="text-[.78rem] leading-[.9rem] text-gray-light1 font-bold">{categoryTitle}</div><div className="w-[.9rem] h-[.9rem] leading-[.9rem] -mt-0.5 flex justify-center items-center [&_img]:h-full">{!menuVisible[`${categoryTitleLower}`] ? <IconArrowRightSimple /> : <ArrowDownSimples width={16} height={9} />}</div></button><div className={classNames("menu-list transition-all duration-700 w-full", {
            "flex flex-col opacity-100": menuVisible[categoryTitleLower],
            "hidden flex-col opacity-0": !menuVisible[categoryTitleLower]
          })}><ul>{subcategory && subcategory.map(_temp)}</ul></div></div>;
      });
    });
    $[8] = data.getNavigationMenus;
    $[9] = menuVisible;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data.getNavigationMenus || $[12] !== menuVisible) {
    t7 = data.getNavigationMenus && data.getNavigationMenus.shop?.map((t8, i_0) => {
      const {
        category: category_0
      } = t8;
      return category_0.map(t9 => {
        const {
          categoryTitle: categoryTitle_0,
          subcategory: subcategory_0
        } = t9;
        let categoryTitleLower_0 = categoryTitle_0.toLowerCase();
        categoryTitleLower_0 = categoryTitleLower_0.replace(" & ", "");
        return <div className="w-full cursor-pointer border-b border-solid border-gray-light5" key={`${categoryTitleLower_0}_${i_0 + 4}`}><button type="button" className="[background:none] border-0 flex w-full flex-row justify-between px-[3.333vw] py-4" onClick={() => toggleMenu(`${categoryTitleLower_0}`)}><div className="text-[.78rem] leading-[.9rem] text-gray-light1 font-normal">{categoryTitle_0}</div><div className="w-[.9rem] h-[.9rem] leading-[.9rem] -mt-0.5 flex justify-center items-center [&_img]:h-full">{!menuVisible[`${categoryTitleLower_0}`] ? <IconArrowRightSimple /> : <ArrowDownSimples width={16} height={9} />}</div></button><div className={classNames("menu-list transition-all duration-700 w-full", {
            "flex flex-col opacity-100": menuVisible[categoryTitleLower_0],
            "hidden flex-col opacity-0": !menuVisible[categoryTitleLower_0]
          })}><ul>{subcategory_0 && subcategory_0.map(_temp2)}</ul></div></div>;
      });
    });
    $[11] = data.getNavigationMenus;
    $[12] = menuVisible;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== firstName || $[15] !== isBrowser || $[16] !== isLoggedIn) {
    t8 = <div className="w-full cursor-pointer border-b border-solid border-gray-light5"><div className="opacity-100 transition-all duration-700"><div className="[background:none] border-0 w-full flex flex-row justify-around">{!isLoggedIn || !isBrowser ? <><button type="button" onClick={evt => {
              evt.preventDefault();
              showSignInModal();
            }}>Login</button><Link className="border-l-[1px] border-solid border-l-gray-light5 w-1/2 text-center px-0 py-4 text-[.78rem] font-normal leading-[.9rem] text-gray-light1 cursor-pointer" to="/contact-us/">Contact Us</Link></> : <><div className="flex flex-col items-center border-l-0 w-full"><div className="pt-4 pb-2 text-[.78rem] font-normal leading-[.9rem]"><span className="break-words">Hi, {firstName}</span></div><div className="pt-0 px-6 pb-4 border-l-0 w-full"><CtaLink to="/customer/dashboard/" hasArrow={false}><IconUserAccount className="w-4" /><div className="no"><span className="[&_button]:p-0 [&_button]:ml-[5px]"><CtaButton style={{
                        background: {
                          padding: 0
                        }
                      }} styling="link" color="brand" size="sm" hasArrow={false} block={true}>Go to Account</CtaButton></span></div></CtaLink></div></div><div className="border-l-[1px] border-solid border-l-gray-light5 w-1/2 text-center px-0 py-4 text-[.78rem] font-normal leading-[.9rem] text-gray-light1 cursor-pointer"><a href="/contact-us/">Contact Us</a><div /></div></>}</div></div></div>;
    $[14] = firstName;
    $[15] = isBrowser;
    $[16] = isLoggedIn;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== signInModalVisible) {
    t9 = <LoginSidebar show={signInModalVisible} onClose={hideSignInModal} />;
    $[18] = signInModalVisible;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="hidden max-[767px]:flex max-[767px]:flex-col max-[767px]:w-full max-[767px]:m-0">{t5}{t6}{t7}{t8}{t9}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default ConsumerMobileFooterMenu;
function _temp(t0) {
  const {
    subcategoryTitle,
    link
  } = t0;
  if (subcategoryTitle === "Reviews") {
    return null;
  }
  if (subcategoryTitle === "Blog") {
    return <li key={`${subcategoryTitle}-link1`}><a key={`${subcategoryTitle}`} href="https://joybird.com/blog/">{subcategoryTitle}</a></li>;
  }
  if (subcategoryTitle === "FAQ") {
    return <li key={`${subcategoryTitle}-link2`}><a key={`${subcategoryTitle}`} href={link}>{subcategoryTitle}</a></li>;
  }
  return <li key={`${subcategoryTitle}-link3`}><Link to={normalizeInternalLink(link)} key={`${subcategoryTitle}`}>{subcategoryTitle}</Link></li>;
}
function _temp2(t0) {
  const {
    subcategoryTitle: subcategoryTitle_0,
    link: link_0
  } = t0;
  return <li key={`${subcategoryTitle_0}-li4`}><Link to={normalizeInternalLink(link_0)} key={`${subcategoryTitle_0}`}>{subcategoryTitle_0}</Link></li>;
}